import { api } from "../../api/axios";
import type { TUtmRequest } from "../types";

export const sendUtm = async (params: TUtmRequest["payload"]) => {
  const { data } = await api.post<TUtmRequest["response"]>("/users-meta", {
    params,
  });
  return data;
};
